import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Subject, takeUntil } from "rxjs";

@Component({
  selector: "app-select-input",
  templateUrl: "./select-input.component.html",
  styleUrls: ["./select-input.component.scss"],
  standalone: false,
})
export class SelectInputComponent {
  @Input() placeholder: any;
  @Input() label: any;
  @Input() isFormSubmitted: boolean = false;
  @Input() class: string = "";
  @Input() dropdownClassName: string = "";
  @Input() allowClear: boolean = false;
  @Input() showSearch: boolean = false;

  @Input() items: any[] = [];
  @Input() valueKey: string = "id";
  @Input() labelKey: string = "name";
  @Input() mode: string = "default";
  @Input() maxTagCount: number = 3;

  @Input()
  set control(control: FormControl) {
    this._control = control;
    this.onControlChange$.next();
  }
  get control(): FormControl {
    return this._control;
  }
  private _control: FormControl = new FormControl();

  private onControlChange$: Subject<void> = new Subject();
  @Output()
  valueChanges = new EventEmitter<any>();

  constructor() {
    this.onControlChange$.subscribe(() => {
      this.control?.valueChanges
        .pipe(takeUntil(this.onControlChange$))
        .subscribe(() => this.valueChanges.emit(this.control.value));
    });
    this.onControlChange$.next();
  }

  getPlaceholder(): string {
    if (
      (this.isFormSubmitted || this.control?.touched) &&
      this.control?.errors
    ) {
      if (this.control.errors["required"]) {
        return `Please select ${this.label}`;
      }
    }
    return this.placeholder;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes["isFormSubmitted"]) {
      this.isFormSubmitted = changes["isFormSubmitted"].currentValue;
    }
  }
}
